import 'core-js/stable'
import 'regenerator-runtime/runtime'

import React from 'react'

import AppLoading from './Components/shared/AppLoading'
import App from './App'
import ReactDOM from 'react-dom'

import AppClearCache from './Components/shared/AppClearCache'

import { BrowserRouter, Route } from 'react-router-dom'
import { Redirect, Switch } from 'react-router-dom/cjs/react-router-dom.min.js'

import reducers from './reducers/index.js'
import { Provider as ReduxProvider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { initialize } from 'react-localize-redux'
import thunk from 'redux-thunk'
import { unregister } from './registerServiceWorker'
import Tracker from './Views/shared/Tracker.jsx'
import RequestPortalProvider from './Providers/RequestPortalProvider'
import { Routes } from './routes.js'

// The next lines are needed to add a language in the app (plus the translations file of course).
// English moment locale is imported by default.
import 'moment/locale/fr'
import 'moment/locale/nl'
import { LanguageLocales, SUPPORTED_LANGUAGE_LOCALES } from './utils/constants.js'
import InternshipRequestPortal from './Views/InternshipRequestPortal/InternshipRequestPortal'
import InternshipRequestPortalSchool from './Views/InternshipRequestPortal/InternshipRequestPortalSchool'
import DisplayIndividualInternshipRequestByToken from './Views/shared/DisplayIndividualInternshipRequestByToken'
import DisplaySchoolPortalRequestByToken from './Views/shared/DisplaySchoolPortalRequestByToken.jsx'

// The default app language is the first in the array.
const languages = [
  { name: 'Français Belgique', code: LanguageLocales.FR_BE },
  { name: 'Français France', code: LanguageLocales.FR_FR },
  { name: 'English', code: LanguageLocales.EN },
  { name: 'Nederlands', code: LanguageLocales.NL },
  { name: 'Português', code: LanguageLocales.PT },
  { name: 'Deutsch', code: LanguageLocales.DE }
]

const middleware = [thunk]
const createStoreWithMiddleware = applyMiddleware(
  ...middleware
)(createStore)

export const store = createStoreWithMiddleware(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
  window.__REDUX_DEVTOOLS_EXTENSION__()
)

// Disabling polyfill warning for "no-template-curly-in-string".
/* eslint-disable no-template-curly-in-string */

// Check if the language was previously saved to localstorage
let previouslySelectedLanguage = LanguageLocales.FR_BE

try {
  previouslySelectedLanguage = global.localStorage.getItem('interneoSelectedLanguage')

  if (!SUPPORTED_LANGUAGE_LOCALES.includes(previouslySelectedLanguage)) {
    previouslySelectedLanguage = LanguageLocales.FR_BE
  }
} catch (err) {
  previouslySelectedLanguage = LanguageLocales.FR_BE
}

global.localStorage.setItem('interneoSelectedLanguage', previouslySelectedLanguage)

store.dispatch(initialize(languages, { missingTranslationMsg: '${key}', defaultLanguage: previouslySelectedLanguage }))

const mainApp = (
  <div className='interneo-app notranslate' translate='no'>
    <ReduxProvider store={store}>
      <BrowserRouter>
        <RequestPortalProvider>
          <Switch>
            <Route path={Routes.CONSULT_INDIVIDUAL_INTERNSHIP_REQUEST}>
              <DisplayIndividualInternshipRequestByToken />
            </Route>
            <Route path={Routes.CONSULT_SCHOOL_PORTAL_REQUEST}>
              <DisplaySchoolPortalRequestByToken />
            </Route>
            <Route path={Routes.REDIRECT_TRACKERS}>
              <Tracker />
            </Route>
            <Route path={Routes.INTERNSHIP_REQUEST_PORTAL_SCHOOL}>
              <InternshipRequestPortalSchool />
            </Route>
            <Route path={[Routes.INTERNSHIP_REQUEST_PORTAL_STUDENT]}>
              <InternshipRequestPortal />
            </Route>
            <Route path='/'>
              <App languages={languages} />
            </Route>
            <Redirect to='/' />
          </Switch>
        </RequestPortalProvider>
      </BrowserRouter>
    </ReduxProvider>
  </div>
)

const app = process.env.NODE_ENV === 'production' ? (
  <AppClearCache>
    {({ loading, isLatestVersion, emptyCacheStorage }) => {
      if (loading) {
        return <AppLoading />
      } else if (!isLatestVersion) {
        setTimeout(() => {
          emptyCacheStorage()
        }, 100)
        return <AppLoading />
      }
      return mainApp
    }}
  </AppClearCache>
) : mainApp

unregister()
ReactDOM.render(app, document.getElementById('root'))
